import kamala from '../../kamala'
import Pagination from './Pagination'

Pagination.install = function (Vue) {
  kamala(Vue)
  Vue.component(Pagination.name, Pagination)
}

export default Pagination
